class AggregateInfoSerializer {
  static deserialize(response) {
    return response
  }
}

export default AggregateInfoSerializer;